export const MODULE_VIEW_PERMISSIONS: Record<string, string | string[]> = {
  'job-profiles': 'jobProfiles.view',
  'work-schedule': 'schedule.view',
  incidents: "incidents.view",
  dashboard: "dashboard.view",
  admin: ["admin.users.view", "admin.shifts.manage"],
  equipment: "equipment.view",
  "equipment-loans": "equipment.view",
  "equipment-defective": "equipment.view",
  "equipment-repair-queue": "equipment.view",
  "equipment-shipments": "equipment.view",
  "equipment-shipped": "equipment.view",
  "equipment-transfers": "equipment.view",
  "equipment-tsd": "equipment.view",
  "equipment-finger_scanners": "equipment.view",
  "equipment-desktop_scanners": "equipment.view",
  "equipment-tablets": "equipment.view",
  "equipment-pc_sets": "equipment.view",
  assets: "assets.view",
  "tmc-calculator": "tmc.view",
  tmc: "tmc.view",
  kanban: "kanban.view",
  tasks: "kanban.view",
  board: "kanban.view",
  "shift-passport": ["shiftPassport.view", "kanban.view", "core.entities.view"],
  "sort-performance": "sortPerformance.view",
  "kpi-shifts": "kpi.view",
  analytics: "analytics.view",
  "parking-balance": "parking.view",
  "camera-map": "cameraMap.view",
  audit5s: "audit5s.view",
  "5s": "audit5s.view",
  visits: "visits.view",
  profile: "dashboard.view",
  notifications: "notifications.view",
};

export function moduleViewPermission(module: string) {
  return MODULE_VIEW_PERMISSIONS[module] || `${module}.view`;
}
